<h2 mat-dialog-title>{{header}}</h2>
<mat-dialog-content>
  <p>{{body}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="mat-secondary" mat-button mat-dialog-close>Cancel</button>
  <button class="mat-flat-button mat-primary" mat-raised-button color="primary" [mat-dialog-close]="true"
          cdkFocusInitial (click)="onConfirm()">{{footer}}</button>
</mat-dialog-actions>
